export function currentMonthRange(date = new Date()) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const pad = (n) => String(n).padStart(2, '0');
  const lastDay = new Date(year, month, 0).getDate();
  return {
    desde: `${year}-${pad(month)}-01`,
    hasta: `${year}-${pad(month)}-${pad(lastDay)}`,
  };
}

export async function downloadCollectionExport(secureFetch, { desde, hasta, format = 'csv' }) {
  const path = format === 'pdf' ? '/api/export/cobranzas/pdf' : '/api/export/cobranzas';
  const res = await secureFetch(`${path}?desde=${desde}&hasta=${hasta}`);
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || 'Error al exportar');
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `cobranzas-${desde}_${hasta}.${format === 'pdf' ? 'pdf' : 'csv'}`;
  a.click();
  URL.revokeObjectURL(url);
}
